import { IoChevronBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

function GoBack({ back }) {
  const navigate = useNavigate();

  return (
    <main className="tw-w-fit pt-lg-4 px-lg-4">
      <button
        onClick={() => navigate(back ? back : -1)}
        className="tw-border tw-border-black/20 tw-text-sm tw-bg-transparent tw-rounded-lg tw-h-10 tw-px-3 tw-p-1 tw-w-fit tw-flex tw-items-center tw-gap-x-1 tw-cursor-pointer"
      >
        {" "}
        <IoChevronBack className="tw-size-4" /> Go Back
      </button>
    </main>
  );
}

export default GoBack;
